import React from 'react';
import './EquipmentAccessSharingDialogPartOfText.less';
import { useTranslation } from 'react-i18next';

interface Props {
  fleetName: string;
}

export default function EquipmentAccessSharingDialogPartOfText({
  fleetName,
}: Props) {
  const { t } = useTranslation();

  return (
    <span className="equipment-access-sharing-dialog-part-of-text">
      <span className="equipment-access-sharing-dialog-part-of-text__label">
        {t('equipment_page.dialogs.access_sharing_dialog.part_of')}
      </span>

      <span className="equipment-access-sharing-dialog-part-of-text__chip">
        {fleetName}
      </span>
    </span>
  );
}
